/* Las Robinson — Theme JS v1.1 */
(function () {
  'use strict';

  /* ── Mobile menu ── */
  var burger   = document.getElementById('lr-hamburger-btn');
  var mobileNav = document.getElementById('lr-mobile-nav');
  var closeBtn  = document.getElementById('lr-mob-nav-close');

  function openNav() {
    if (!mobileNav) return;
    mobileNav.classList.add('is-open');
    mobileNav.setAttribute('aria-hidden', 'false');
    if (burger) burger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeNav() {
    if (!mobileNav) return;
    mobileNav.classList.remove('is-open');
    mobileNav.setAttribute('aria-hidden', 'true');
    if (burger) burger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  if (burger) burger.addEventListener('click', function () {
    mobileNav && mobileNav.classList.contains('is-open') ? closeNav() : openNav();
  });

  if (closeBtn) closeBtn.addEventListener('click', closeNav);

  // Close on ESC key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeNav();
  });

  /* ── CP delivery lookup table ── */
  var CP = {
    '28001':5,'28002':7,'28003':7,'28004':7,'28005':7,'28006':5,'28007':6,'28008':10,'28009':5,'28010':7,
    '28011':14,'28012':7,'28013':7,'28014':7,'28015':10,'28016':7,'28017':14,'28018':11,'28019':14,'28020':12,
    '28021':16,'28022':15,'28023':14,'28026':10,'28027':9,'28028':5,'28030':12,'28031':13,'28032':15,
    '28033':13,'28036':9,'28037':13,'28038':15,'28039':12,'28040':11,'28041':15,'28042':19,'28043':12,
    '28045':8,'28053':15,'28100':16,'28108':18,'28109':19,'28220':23,'28221':24,'28222':24,'28223':17,
    '28224':18,'28230':26,'28231':27,'28232':28,'28521':21,'28522':20,'28523':22,'28524':23,'28529':26,
    '28820':19,'28821':19,'28822':20,'28823':21,'28824':21,'28830':22,'28901':21,'28902':22,'28903':22,
    '28904':20,'28905':21,'28906':22,'28907':23,'28909':20,'28911':21,'28912':22,'28913':23,'28914':22,
    '28915':23,'28916':21,'28917':20,'28918':23,'28919':23,'28921':21,'28922':21,'28923':22,'28924':23,'28925':22
  };

  /* ── Cart CP section ── */
  var cpInput   = document.getElementById('lr-cp-input');
  var cpResult  = document.getElementById('lr-cp-result');
  var shippingEl = document.getElementById('lr-shipping-cost');
  var totalEl   = document.getElementById('lr-order-total');
  var subtotal  = window.LR_SUBTOTAL || 0;

  if (cpInput) {
    cpInput.addEventListener('input', function () {
      var v = this.value.replace(/\D/g, '').slice(0, 5);
      this.value = v;
      if (v.length === 5) { checkCP(v); }
      else { hideCPResult(); setShipping(null); }
    });
  }

  function checkCP(cp) {
    if (!cpResult) return;
    if (CP[cp] !== undefined) {
      cpResult.className = 'lr-cp-result lr-cp-ok';
      cpResult.textContent = '✓ Zona cubierta · Envío: ' + CP[cp] + '€';
      setShipping(CP[cp]);
    } else {
      cpResult.className = 'lr-cp-result lr-cp-no';
      cpResult.textContent = 'CP fuera de zona. Escíbenos por WhatsApp.';
      setShipping(null);
    }
  }

  function hideCPResult() {
    if (cpResult) { cpResult.className = 'lr-cp-result'; cpResult.textContent = ''; }
  }

  function setShipping(cost) {
    if (shippingEl) shippingEl.textContent = cost !== null ? cost + '€' : '—';
    if (totalEl) {
      totalEl.textContent = cost !== null
        ? (subtotal + cost) + '€'
        : subtotal + '€ + envío';
    }
  }

  /* ── Delivery type toggle ── */
  var tipoSelect = document.getElementById('lr-tipo-entrega');
  var cpSection  = document.getElementById('lr-cp-section');

  if (tipoSelect) {
    tipoSelect.addEventListener('change', function () {
      var val = this.value;
      if (cpSection) cpSection.style.display = val === 'domicilio' ? 'block' : 'none';
      hideCPResult();
      if (val === 'recogida') {
        if (shippingEl) shippingEl.textContent = '0€ (recogida)';
        if (totalEl) totalEl.textContent = subtotal + '€';
      } else {
        setShipping(null);
      }
    });
  }

  /* ── Date picker — block within 48h ── */
  var dateInput   = document.getElementById('lr-delivery-date');
  var dateError   = document.getElementById('lr-date-error');
  var franjaSelect = document.getElementById('lr-franja');

  if (dateInput) {
    var minD = new Date();
    minD.setHours(minD.getHours() + 48);
    dateInput.min = minD.toISOString().split('T')[0];

    dateInput.addEventListener('change', function () {
      var sel   = new Date(this.value + 'T12:00:00');
      var limit = new Date();
      limit.setHours(limit.getHours() + 48);
      if (sel < limit) {
        if (dateError) { dateError.style.display = 'block'; dateError.textContent = 'Necesitamos mínimo 48h de antelación. Elige una fecha posterior.'; }
        if (franjaSelect) franjaSelect.innerHTML = '<option>Elige una fecha válida</option>';
        return;
      }
      if (dateError) dateError.style.display = 'none';
      populateSlots(sel.getDay());
    });
  }

  function populateSlots(day) {
    if (!franjaSelect) return;
    var weekend = day === 0 || day === 6;
    var slots = weekend
      ? ['09:00–10:00','10:00–11:00','11:00–12:00','12:00–13:00']
      : ['09:00–10:00','10:00–11:00','11:00–12:00','12:00–13:00',
         '13:00–14:00','14:00–15:00','15:00–16:00','16:00–17:00','17:00–18:00','18:00–19:00'];
    franjaSelect.innerHTML = slots.map(function (s) { return '<option>' + s + '</option>'; }).join('');
  }

  /* ── Product qty selector ── */
  document.querySelectorAll('.lr-qty-wrap').forEach(function (wrap) {
    var minus = wrap.querySelector('[data-qty="minus"]');
    var plus  = wrap.querySelector('[data-qty="plus"]');
    var inp   = wrap.querySelector('[data-qty="val"]');
    if (!inp) return;
    if (minus) minus.addEventListener('click', function () {
      var v = parseInt(inp.value, 10) - 1;
      if (v >= 1) inp.value = v;
    });
    if (plus) plus.addEventListener('click', function () {
      inp.value = parseInt(inp.value, 10) + 1;
    });
  });

  /* WhatsApp order link now lives in sections/main-cart.liquid (#lr-wa-order-btn),
     which builds the full order summary and gates the button on form validation.
     The old handler here was stale (referenced pre-rewrite field IDs) and fired
     a second, generic wa.me window alongside the real one — removed. */

})();
